import CommercialStagingForm from "./CommercialStagingForm"

const FloorPlanForm = () => {
    return (
        <CommercialStagingForm />
    )
}

export default FloorPlanForm;